import React from 'react'
import { NavLink } from 'react-router-dom'
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
import { Link } from "react-router-dom";
export default function Footer_site() {
  return (
    <>
          <footer>
	<div className="container">
		<div className="row listpge">
			<div className="col-md-5ths col-sm-5ths">
				<div className="ulsme">
					<h3>Logo Services</h3>
					<ul>
						<li><Link to="/Main_logo">Logo Design</Link></li>
						<li><ScrollLink 
						  to="pricing"
						  spy={true}
						  smooth={true}
						  offset={50}
						  duration={500}
						>Logo Packages</ScrollLink></li>
						{/* <!-- <li><a href="/javascript:;">How it Works</a></li> --> */}
						<li><ScrollLink 
						 spy={true}
						 smooth={true}
						 offset={50}
						 duration={500}
						to="porfolio">Logo Portfolio</ScrollLink></li>
						<li><Link
						 spy={true}
						 smooth={true}
						 offset={0}
						 duration={500}
						to="/Review">Reviews</Link></li>
					</ul>
				</div>
			</div>
			<div className="col-md-5ths col-sm-5ths">
				<div className="ulsme">
					<h3>Website Services</h3>
					<ul>
						<li><Link to="/Website">Website Design</Link></li>
						<li><ScrollLink to="#web_pricing">Website Packages</ScrollLink></li>
						{/* <!-- <li><a href="/javascript:;">How it Works</a></li> --> */}
						<li><ScrollLink top="web_portfolio">Website Portfolio</ScrollLink></li>
						<li><Link to="/Review">Reviews</Link></li>
					</ul>
				</div>
			</div>
			<div className="col-md-5ths col-sm-5ths">
				<div className="ulsme-ctact">
					<h3>Other Services</h3>
					<ul>
						<li><a>Animated Videos</a></li>
						<li><a>Brochure Design</a></li>
						<li><a>Stationery Design</a></li>
						<li><a>Banner Design</a></li>
						<li><a>Packaging Design</a></li>
					</ul>
				</div>
			</div>
			<div className="col-md-5ths col-sm-5ths">
				<div className="ulsme">
					<h3>Quick Links</h3>
					<ul>
						{/* <li><Link to="/Home">Home</Link></li> */}
						<li><Link to="/About">About Us</Link></li>
						<li><Link to="/Website">Web Design</Link></li>
						<li><Link to="/Branding_design">Branding</Link></li>
						<li><Link to="/Portfoli">Portfolio</Link></li>
						{/* <!-- <li><a href="/sitemap.php">Sitemap</a></li> --> */}
					</ul>
				</div>
			</div>
			<div className="col-md-5ths col-sm-5ths">
				<div className="ulsme-ctct">
					<h3>Contact Us</h3>
					<ul>
						<li className="phone-list"><a href="tel:+442032898634">+44 20 3289 8634</a></li>
						<li className="email-list"><a href="mailto:info@websetdigital.com">info@websetdigital.com</a></li>
						{/* <!-- <li className="chat-list"><a href="javascript_%3b.html" className="chat">Live Chat</a></li> --> */}
						<li className="address-list"><a>Lytchett House, 13 Freeland Park, Wareham Road, Poole, Dorset, BH16 6FA</a></li>
					</ul>
				</div>
			</div>
		</div>
		<div className="row brdr-top ">
			<div className="col-md-6 col-sm-6 col-xs-6">
				<div className="footer-logo padd-btd">
					<img className="img-responsive" src="images/webions_logo_trans.png"/>
				</div>
			</div>
			<div className="col-md-6 col-sm-6 col-xs-64">
				<div className="social-icons padd-btd">
					<h4>Follow Us</h4>
					<a href="https://www.facebook.com/websetdigital/" target="_blank"><i className="fa-brands fa-facebook-f"></i></a>
					<a href="https://www.instagram.com/websetdigital/?hl=en" target="_blank"><i className="fa-brands fa-instagram"></i></a>
					<a href="https://pk.linkedin.com/company/websetdigital" target="_blank"><i className="fa-brands fa-linkedin-in"></i></a>
				</div>
			</div>
		</div>
	</div>
	<div className="footer-bottom">
		<div className="container">
			<div className="row">
				<div className="col-md-12">
					<h4>© Copyright 2023. All Rights Reserved By Webset Digital
					</h4>
					<p>Disclaimer: The logo, name and graphics of Webset Digital and its products & services are the trademarks of Webset Digital. All other company names, brand names, trademarks and logos mentioned on this website are the property of their respective owners and do not constitute or imply endorsement, sponsorship or recommendation thereof by Webset Digital and do not constitute or imply endorsement, sponsorship or recommendation of Webset Digital by the respective trademark owner.</p>
				</div>
			</div>
		</div>
	</div>
</footer>
    </> 
  )
}